import { render, staticRenderFns } from "./PageHeader.vue?vue&type=template&id=2a9115a5&scoped=true"
import script from "./PageHeader.vue?vue&type=script&lang=ts"
export * from "./PageHeader.vue?vue&type=script&lang=ts"
import style0 from "./PageHeader.vue?vue&type=style&index=0&id=2a9115a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a9115a5",
  null
  
)

export default component.exports